module.exports = __webpack_public_path__ + "static/yearend-party-2.263adfc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageYearEndParty/images/yearend-party-2.jpg
// module id = 782
// module chunks = 152659631335596